/* istanbul ignore file */
export * from './PageMetaData';
